module.exports = __webpack_public_path__ + "img/wizardHat.4dc23c02.svg";